import { getRouteApi } from '@tanstack/react-router'
import { PageSectionFace } from 'ui/components/Page'
import { Pagination } from 'ui/components/Pagination'
import { NoResultsFound } from 'ui/temp'
import { AdverseMediaDetailsType } from '~bank-adverse-media/types/details'

import { Filter, Publication } from './components'

import { s } from './styles'

const routeApi = getRouteApi('/_app/adverse-media/$id')

export const PublicationsListContainer = () => {
  const navigate = routeApi.useNavigate()

  const data = routeApi.useLoaderData() as AdverseMediaDetailsType
  const searchParams = routeApi.useSearch()

  const { publications } = data
  const { publicationsPage, publicationsSize } = searchParams

  return (
    <s.WrappedPageSection face={PageSectionFace.THIRD} title="News" anchor="news">
      <Filter />

      {publications && publications.length > 0 ? (
        <>
          {publications.map((publication) => (
            <Publication key={publication.id} publication={publication} />
          ))}
          <Pagination
            page={publicationsPage || 1}
            size={publicationsSize || 10}
            total={data.publicationsTotalCount}
            withSize
            onPageChange={(page, size) =>
              navigate({
                to: '.',
                search: (prev) => ({ ...prev, publicationsPage: page, publicationsSize: size }),
                resetScroll: false
              })
            }
          />
        </>
      ) : (
        <NoResultsFound
          title="No Adverse Media results found."
          subTitle="Please try to select another Publication status."
        />
      )}
    </s.WrappedPageSection>
  )
}
